var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.99988L17.0303 4.46955C16.7374 4.17665 16.2626 4.17665 15.9697 4.46955L16.5 4.99988ZM19.5 7.99988L20.0305 8.53C20.3232 8.23707 20.3231 7.76236 20.0303 7.46955L19.5 7.99988ZM8.5 18.9999L8.50001 19.7499C8.69888 19.7499 8.88961 19.6709 9.03025 19.5303L8.5 18.9999ZM5.5 18.9999H4.75C4.75 19.1988 4.82902 19.3896 4.96967 19.5303C5.11033 19.6709 5.3011 19.7499 5.50001 19.7499L5.5 18.9999ZM5.5 15.9999L4.96967 15.4695C4.82902 15.6102 4.75 15.801 4.75 15.9999H5.5ZM16.5024 10.9999L17.0326 11.5303L17.0329 11.53L16.5024 10.9999ZM15.9697 5.53021L18.9697 8.53021L20.0303 7.46955L17.0303 4.46955L15.9697 5.53021ZM8.49999 18.2499L5.49999 18.2499L5.50001 19.7499L8.50001 19.7499L8.49999 18.2499ZM6.25 18.9999V15.9999H4.75V18.9999H6.25ZM18.9695 7.46976L15.9719 10.4698L17.0329 11.53L20.0305 8.53L18.9695 7.46976ZM15.9721 10.4695L7.96975 18.4695L9.03025 19.5303L17.0326 11.5303L15.9721 10.4695ZM6.03033 16.5302L14.0303 8.53021L12.9697 7.46955L4.96967 15.4695L6.03033 16.5302ZM14.0303 8.53021L17.0303 5.53021L15.9697 4.46955L12.9697 7.46955L14.0303 8.53021ZM12.9699 8.53042L15.9723 11.5304L17.0325 10.4693L14.0301 7.46934L12.9699 8.53042Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.29b8e3d14db1a9bf21c4ab12f59b041d.svg";
export { ForwardRef as ReactComponent };